export const USERROLES = {
  ADMIN: "SUPER_ADMIN",
  SOLICITOR: "SOLICITOR",
  CLIENT: "CLIENT",
  MORTGAGEBROKER: "MORTGAGE_BROKER",
  ESTATEAGENT: "ESTATE_AGENT",
  SALESAGENT: "SALES_AGENT",
};
